import { websitname, email, account } from "../common/project.config";

export default {
  title: {
    defaulttitle: `Sign in to ${websitname} - Find Friends Here!`,
    home: "Home",
    signin: `Sign in to ${websitname} - Find Friends Here!`,
    signup: `Join ${websitname} - Find Friends Here!`,
    about: "ABOUT US",
    terms: "TERMS OF USE",
    privacy: "PRIVACY POLICY",
    refund: "REFUND AND CANCELLATION",
    help: "HELP CENTER",
    contact: "CONTACT US",
  },
  regist: {
    title: "JOIN OUR COMMUNITY",
    subtitle:
      "Join our fast-growing community. Find new friends, date up, share photo and video. Enjoy!",
    registp: "REGISTER YOUR PROFILE",
    formtitlte: "Basic",
    username: "Username",
    containe: "Should contain only letters and digits",
    email: "Email",
    valid: "Should be valid",
    pwd: "Password",
    pwdc: "Repeat password",
    laid: "Lai ID",
    gender: "Gender",
    male: "Male",
    female: "Female",
    birth: "Birthday",
    country: "State",
    singce: "From which country?",
    terms: "Terms of use",
    agree: "I agree with it",
    signup: "JOIN",
    form: {
      required: "Please input the",
      pwdnomatch: "Passwords does not match",
      used: "has been used",
      faile: "Registration failure",
      seccess: "Registration success",
      fomate: "format error",
    },
    year: "Year",
    month: "Month",
    date: "Date",
  },
  forgot: {
    title: "ENTER YOUR EMAIL",
    subtitle: "Type the email address you used at registration.",
    uremail: "Your email address",
    sunmit: "GO",
  },
  login: {
    forgot: "Forgot Password",
    signinp: "PLEASE SIGN IN",
    username: "Username",
    email: "Email",
    pwd: "password",
    remember: "Remember me",
    signin: "SIGN IN",
    join: "Join",
    form: {
      error: "Incorrect username or password",
      success: "Login successful",
    },
    download: "download",
    aboutus: "Join now",
    register: "Register now",
  },
  loginfooter: {
    about: "ABOUT US",
    terms: "TERMS OF USE",
    privacy: "PRIVACY POLICY",
    refund: "REFUND AND CANCELLATION",
    help: "HELP CENTER",
    contact: "CONTACT US",
  },
  loginmenu: {
    signin: "Sign In",
    signup: "Sign Up",
  },
  websit: {
    signin: "SIGNIN",
    join: "JOIN",
    about: {
      title: "ABOUT US",
      item_1_title: "COMPANY PROFILE",
      item_1_content:
        "Our website committed to develop online dating service industries in more than 230 countries and regions, and manage multiple websites in different languages. Here you can enjoy the fun and joy to share with friends, to provide you with a world's most efficient, most fun dating platform, every day hundreds of new members to join.",
      item_2_title: "WHAT IS OUR MISSION?",
      item_2_content:
        "Our mission is simple: to help you make friends from around the world come from. We think: this regard, we are doing pretty good. Every month we have received letters from all over the world to share their knowledge with friends on Our website story with us.",
      item_3_title: "HOW TO OPERATE?",
      item_3_content:
        "We provide knowledge and understanding of friends around the world the opportunity for users to write freely through the different pages, so that they themselves described in detail in its files. You can upload multiple pictures, and information about their hobbies. We know the importance of privacy, so all contact between members are via anonymous e-mail networks. We are all members of the names and contact information are confidential, unless the members, except they want to share personal information with each other, once registered, members can view photos immediately and logs potential friends and contact them.",
    },
    terms: {
      title: "TERMS OF USE",
      item_1_title: "1. AGREE TO TERMS OF USE",
      item_1_content:
        "This Agreement (Terms of Use), including present and future business website and the client. By using this service, whether or not you register as a website members (hereinafter referred to as members), you will be deemed to have agreed to these terms of use. If you do not agree to this Terms of Service, please stop using our services.",
      item_2_title: "2. ELIGIBILITY REQUIREMENTS",
      item_2_content:
        "Minors under the age of 18 years shall not use our services. By using our service, you represent and warrant that you have the right and ability to comply with all the provisions of the Terms of Use.",
      item_3_title: "3. CHANGES TO THE TERMS OF USE",
      item_3_content:
        "Our website reserves the right without prior notice, to change these Terms of Use. You can view the Terms of Service to change the situation on a regular basis. When we make changes to the terms of use, if you use our services, whether or not you view that you agree to these changes.",
      item_4_title: "4. PRIVACY",
      item_4_content:
        "Our website respect the privacy of site visitors. Using the service should follow our privacy policy. Our website partners agreed to follow the provisions of the privacy policy",
      item_5_title: "5. SERVICE CHANGE",
      item_5_content:
        "Our website can decide to add, delete or modify services or the services without prior notice.",
      item_6_title: "6.CUSTOM",
      item_6_subtitle1: "A) PAYMENT",
      item_6_subtitlecontent1:
        "Payment information will be transmitted as a fee incurred by the service you have agreed to purchase, and the result will be determined by the return information between you and a financial institution, a credit card issuer or other payment service provider of your choice. If our website does not accept payment services provided by your Payment Service Provider, you can pay all the amount you need and agree to continue using our services. If your account has been paid, you can ask us to cancel the status of your payment. Once your account has been cancelled, your payment status will expire on the date of your final payment. The paid status is not transferable. The paid status of Our website is final sales, and no refund can be made. Members will not automatically deduct the cardholder's renewal fee after the expiry of the month or quarter. If members want to continue to use it, they need to recharge it manually. The disputed fee should be reported to Our website within 60 days after you purchase the service. If you have any questions about your paid status, please contact us for settlement.",
      item_6_subtitle2: "B) SERVICE CONTRACT",
      item_6_subtitlecontent2:
        "You order at Our website site service will not automatically renew. You can contact our customer service team at any time to change or re-ordered. If you choose to order, your order will expire at the service does not automatically renew. Canceled before the expiry custom-made, can not get a refund.",
      item_6_subtitle3: "C)FREE TRIAL AND OTHER PROMOTIONAL",
      item_6_subtitlecontent3:
        "Any free trial or other promotional methods, can be customized to use our services in a specific trial period. If users need to order promotional service provisions, you should cancel the order before the trial period in order to avoid delivery of custom fees.",
      item_7_title: "7. JOIN OUR WEBSITE THROUGH PARTNERS",
      item_7_content:
        "If you register to use our services through partners Our website, and Our website with its partners to provide the service. You will have the right to use members of the service, and Our website the right to transfer your membership or paid to transfer your account to the Our website similar services.",
      item_8_title: "8. COMMUNITY CONTENT",
      item_8_content: `All services should follow the requirements of community content guidelines. You agree not to publish, transmit, distribute or link to anything involving unlawful, harassing, defamatory, threatening, harmful, obscene, rebellious, libel, slander the reputation of others, and violations of the privacy of others of the content, nor send other people unhappy, or rather against other human rights groups or content. Intellectual property without the written consent of the person shall not use the intellectual property of others, including information protected by copyright and trademark protection, alteration or change of intellectual property rights of others, such as non-copyright text or pictures. Our website will not be any mail sent by members or groups responsible for the content of the discussion thread, any information, goods or services are not responsible for third party or members of. Use our services, you agree that: In the following cases, Our website will not be responsible to you or others: for example: a threat to any party, defamatory, obscene, indecent, attack or offense, or tort, including the illegal use of knowledge property rights. Our website does not have all the information you provide to (including feedback and suggestions), or you publish Our website, download, input or submit all the information ("submitted information"). However, if you posted on our Web site or client, uploading, inputting, providing or submitting information, you indicate that you give Our website perpetual and irrevocable right to transfer, Our website the right to copy, use, store, modify, edit, translate or publish any or all of the information you have submitted, and without payment of royalties information. Our website no obligation to post or use the information you submit and Our website can always decide to delete the information you have submitted. In this website you download, input or submit information that indicates that you have your control over the release of information. For your information is deleted, invalid or failure to store, Our website and its partners will not be held responsible.`,
      item_9_title: "9. MEMBER ACCOUNT",
      item_9_content:
        "Once you sign up for our service, you will receive an account number and password, you are responsible for your account and password confidential, and shall be responsible for all activities related to your account. Once registered as a member, you will be responsible for all of your information files. Prohibited publication of pornographic or other obscene content in the file or web service project, because it would threaten your membership. For the next line dating site members Our website, Our website will not take any responsibility. You agree Our website send mail (involving service information (including changes to upgrade), new features or events, use the services of the observations and recommendations) to you.",
      item_10_title:
        "10. MATERIALS PROTECTED BY COPYRIGHT AND TRADEMARK PROTECTION",
      item_10_content:
        "Content Our website are protected by copyright Copyright © 2011-2019.",
      item_11_title: "11. DISCLAIMER",
      item_11_content: `In Our website or published by Our website (or Our website agents or partners) information, according to "existing" and "existing" offer. It does all kinds of express or implied warranties and conditions. Our website does not control any information, products or services provided by third parties. You expressly agree that use of the service will bear the risk alone. The fullest extent permissible pursuant to applicable law: Our website on all express or implied warranties, disclaimers, and such warranty including but not limited to implied merchantability and ensure suitability for special purposes; Our website does not guarantee provided service to meet your needs, does not guarantee the service will be uninterrupted, timely, secure or correct. Our website not for service use and use the results as collateral. Our website does not warrant that this website or services does not contain any viruses or other harmful components. Our website does not warrant or represent that: keep the site transfer information confidential. Our website website does not guarantee the accuracy and completeness of the translation. Our website do not guarantee the following: any goods or services purchased or obtained through this website, or to advertise on this site or sponsorship of goods or services, or any transaction conducted through this website. Information Our website not you receive services from Our website or make any express warranties (whether oral or written).`,
      item_12_title: "12.STATEMENT",
      item_12_content1: `All the gifts on this website are virtual gifts.`,
      item_12_content2: `All the items above are organized and regulated under the laws of united kingdom. the online merchant is located in uk. the billing statement name will be '${account}'.`,
      item_12_content3: `GOVERNING LAW- These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the HK laws.`,
    },
    privacy: {
      title: "PRIVACY POLICY",
      item_0_content: `${websitname} respect the privacy of users and to develop privacy policies to protect your privacy. Privacy policy include: user case ${websitname}, we collect information, how to use this information and share this information with anyone. When you use our web site or service, or business transaction with us, we recommend that you carefully read the "Privacy Policy." By using our website, indicates that you have accepted the provisions of the confidentiality agreement. ${websitname} online privacy very seriously. If you have any questions about this privacy policy, please contact us.`,
      item_1_title: "PERSONS UNDER 18 YEARS OF AGE",
      item_1_content: `${websitname} not knowingly collect or maintain under the age of 18 who personally identifiable information and non-personally identifiable information, any item on this site under the age of 18 who are not facing the open. If you are under 18, please stop using or prohibit access to the Site or the Service. If ${websitname} learned the information collected under 18 years of age who personally identifiable information, this website will take reasonable steps to remove the information.`,
      item_2_title: "THE INFORMATION WE COLLECT",
      item_2_content: `You fill in the relevant information (including your personal information, contact information, and other file information when you create a member profile filled out); freedom when you fill out customer surveys, provide feedback and participate in the competition, provided the relevant information ; If you contact us, we will record your communication information; transaction information including your order from our website information about products and services; visit our website visitors, and their information has been recorded, may be entitled to the same login information and the right to correct information or to view the policies and rules of the relevant information. Visitors can contact us directly.`,
      item_3_title: "INFORMATION COLLECTED OTHERS",
      item_3_content: `We allow third parties (including our authorized service providers, advertising companies and advertising sites) in advertisements published on our website. If you open a link (such as an ad banner), which will allow you to leave our site, log in to other sites, if you subsequently provide information on other sites, we will not be able to control the use of this information. This Privacy Policy shall not be liable to other websites or advertisers information confidential. For other sites on how to use your information, ${websitname} will not bear any responsibility for this purpose.`,
      item_4_title: "HOW DO WE USE THE INFORMATION COLLECTED?",
      item_4_content1: `Manage your user account (including: inform you of any object that matches, tips, announcements, updates or promotions`,
      item_4_content2: `Help you customize a personalized website visit`,
      item_4_content3: `Are asked to provide your information, products or services, or information you are interested in; conduct market analysis and survey`,
      item_4_content4: `Help us improve our service structure, layout, and applicability`,
      item_5_title: "WE SHARE THE INFORMATION COLLECTED AND WHO",
      item_5_content: `We may be at particular aspects of sharing your information with third parties, such as: When you order the service from our website, we provide your information to a third party payment processing. But we will control the third party to use your information, and responsible. We have some of your information may be disclosed to our partner companies in order to provide you with services such as: e-mail or chat services. To provide these services, we have your information (including your username and email address ${websitname}) to our partners.`,
      item_6_title: "COOKIES",
      item_6_content: `We tried to follow your preferences for your service. We use Cookies to save and recorded information about you. Cookie refers sent to your browser by a web server a small portion of the data, the data stored on your computer's hard drive.`,
      item_7_title: "PRIVACY POLICY CHANGES",
      item_7_content: `We regularly review the "Privacy Policy", and announced the policy change information on this page. We encourage members to regularly review our privacy policy to better understand the information we collect and how we use the information, and under what circumstances the use of information and share information with others.`,
      item_8_title: "HOW TO CONTACT US",
      item_8_content: `If you respect this privacy policy or our information handling any questions, or for us to disclose information to third parties (for direct marketing purposes) have questions, please contact us with email or letter. E-mail: %{email}`,
    },
    refund: {
      title: "REFUND AND CANCELLATION",
      item_1_title: "REFUND AND CANCELLATION",
      item_1_content: `When you consume, because the payment order passes through different banks, there may be differences in the return of the payment. If you have any questions about the return of the order, you can contact the website customer service and explain.`,
      item_2_title: "REFUND",
      item_2_content: `If you have any questions about the transaction order, you need to contact the website customer service, and the customer service will help explain the order situation. For refund processing, it usually takes more than one week according to the refund process. Pay attention to check the refund information of your card issuing bank.`,
      item_3_title: "CANCELLATION",
      item_3_content1: `If the transaction order has been successfully recharged, after contacting the customer service of the website, a refund can be made after negotiation. According to the refund process, it usually takes more than one week. Please check the refund information of your card issuing bank.`,
      item_3_content2: `Email:  %{email}`,
    },
    help: {
      title: "HELP CENTER",
      item_1_title: "1. I CAN NOT LOG IN",
      item_1_content: `Please confirm that you have registered a ${websitname} account and entered the correct account details and password.`,
      item_2_title: "2. FORGOT YOUR PASSWORD",
      item_2_content: `The "Forgot Password" option is on the sign-in page.`,
      item_3_title: "3. HOW TO UPGRADE MEMBERSHIP",
      item_3_content: `You can click on the upgrade membership icon button, then choose what you want to upgrade the membership level upgrade.`,
      item_4_title: "4. HOW TO BETTER USE THE TRANSLATION FEATURE",
      item_4_content: `${websitname} site is a global SNS for international dating sites, where by ${websitname}translation platform for global communication and unlimited friends! When you have a higher membership privileges, you will be able to enjoy more of the translation privileges.`,
      item_5_title: "5. HOW TO REPORT ILLEGAL ACCOUNT",
      item_5_content: `When you find some illegal account, you can enter his personal home page, click "Report." Webmaster or contact us, we will make a survey and processed to ensure the safety of the site.`,
      item_6_title: "6. HOW TO PAY",
      item_6_content: `You can log ${websitname} clicking recharge, we currently network security payment, all payment methods are absolutely safe. This website absolutely no memory of any automatic or recurring charges of procedure. Have any questions, please contact the webmaster Ask your questions.`,
      item_7_title: "7.RECHARGE UNSUCCESSFUL",
      item_7_content: `If you are unable to successfully recharge the prepaid page ${websitname}, first check your credit card if there is a problem, then replace the browser and try again. Sometimes you can also choose to contact PayPal (eg prompted \ "on your credit card can not be used to pay the transaction \" case). After a variety of methods to try if still unable to successfully recharge, please tell us the details, such as what you are using prepaid way, what error message? What kind of browser? In order to help our technical staff to quickly find the cause to help you solve the problem, you will send us a screenshot of the error page as the site administrator.`,
    },
    contact: {
      title: "CONTACT US",
      item_0_content: `Email: %{email}`,
    },
  },
  authority: {
    Allow_profile_wall_posts: "Allow profile wall posts",
    Search_users: "Search users",
    View_profiles: "View profiles",
    Auth_message: "Auth message",
    Allow_comments_on_newsfeed: "Allow comments on newsfeed",
    Dynamic_unrestricted: "Dynamic unrestricted",
    Allows_newsfeed_to_be_sent: "Allows newsfeed to be sent",
    Upload_photo: "Upload photo",
    View_photo: "View photo",
    Comment_photo: "Comment photo",
    Add_video: "Add video",
    View_video: "View video",
    Comment_video: "Comment video",
    Start_mail_dialog: "Start mail dialog",
    Continue_mail_dialog: "Continue mail dialog",
    Read_chat_messages: "Read chat messages",
    Send_chat_messages_for_free: "Send chat messages for free",
    Start_chat_dialog: "Start chat dialog",
    Read_mails: "Read mails",
    Continue_chat_dialog: "Continue chat dialog",
    Free_use_of_the_translation_function:
      "Free use of the translation function",
  },
  home: {
    index: "MAIN",
    member: "MEMBER",
    chat: "CHAT",
    recharge: "RECHARGE",
    upgrade: "UPGRADE",
    store: "STORE",
    photo: "PHOTO",
    mails: "MAILS",
  },
  dynamic: {
    dynamic: "Dynamic",
    photo: "Photo",
    personaldata: "personal data",
    like: "like",
    detele: "Delete background picture",
    upload: "Upload background image",
  },
  index: {
    member: "MEMBERS",
    mycredits: "MY CREDITS",
    balance: "Credit balance",
    user: "USERS",
    trend: "NEWSFEED",
    pay: "Buy more",
    latest: "Latest",
    online: "Online",
    viewall: "View all",
    invite: "INVITE FRIENDS",
    showpath: "Show Invitation Path",
    photo: "PHOTOS",
    copy: "Copy",
  },
  trend: {
    joined: "Joined our site!",
    edited0: "Edited her profile details.",
    edited1: "Edited his profile details.",
    avatar0: "Modified her avatar.",
    avatar1: "Modified his avatar.",
  },
  member: {
    whole: "Whole",
    online: "Online",
    latest: "Latest",
    mylike: "MyLike",
    likeme: "LikeMe",
    mutua: "MutuaLike",
    search: "SEARCH",
    searchbyname: "Search by name",
    follow: "Follow",
    cancelfollow: "Cancel Follow",
    sendgift: "Send gift",
    chatnow: "CHAT NOW",
    usersearch: "USER SEARCH",
    browseuser: "BROWSE USER",
    basic: "basic",
    year: " years",
  },
  recharge: {
    self: "Recharge for self",
    pay: "Recharge",
  },
  pay: {
    name: "Cardholder's name",
    ename: "Please fill in your English name",
    lastname: "Cardholder's last name",
    cardnumber: "Card number",
    Expiration: "Expiration date",
    CVV: "CVV",
    country: "Card country",
    state: "Card state",
    city: "Card city",
    address: "Card address",
    phone: "Card fullPhone",
    ZipCode: "Card ZipCode",
  },
  upgrade: {
    silver: "Diamond Card",
    gold: "Crown Card",
    Rechargesuccess: "Recharge success",
    Paymentfailed: "Payment failed",
    runninglow: "Sorry, your credit is running low",
    choosemeal: "Please choose a set meal",
    actuallypaid: "amount actually paid",
    paymentmethod: "payment method",
    month: "month(s)",
    province: "Province",
    usd: "USD",
    onlyDomain: "Only available on kissmeaa.top domain."
  },
  store: {
    store: "STORE",
    gift: "Virtual gifts",
    receive: "ME RECEIVED",
    sendgift: "Send gift",
    credits: "Credits",
    username: "Username",
    msg: "Leave a message",
    send: "send",
  },
  user: {
    setup: {
      myavatar: "My head",
      setting: "Data setting",
      signature: "Personal signature",
      languge: "language",
      changepwd: "Change password",
      photograph: "take a picture",
      Choosefromalbum: "Choose from album",
      UsedAvatar: "Used Avatar",
      Basicinformation: "Basic information",
    },
    edit: {
      title: "Edit Infomation",
      avatar: "Avatar",
      changepwd: "Change Password",
      oldpwderror: "The old password is incorrect",
      oldpwd: "Old password",
      modifiedsuccess: "Modified success",
      modifiedfail: "Modification failed",
      save: "Save",
      cancel: "Cancel",
      trendplaceholder: "What's happening?",
      modifyavatar: "Modify your avatar",
      signatureplaceholder: "Add some info about yourself here",
    },
    sendemail: "Chat",
    follow: "Follow",
    gift: "Send Gift",
    report: "Report",
    photo: "Photo",
  },
  message: {
    address: "address",
    message: "MESSAGE",
    msg: "content",
    newmsg: "New Message",
    send: "Send Message",
  },
  global: {
    send: "Send",
    save: "Save",
    confirm: "Confirm",
    cancel: "Cancel",
    search: "Search",
    modify: "Modify",
  },
  empty: {
    nouser: "No User",
    nophoto: "No Photo",
    noresult: "No Result",
    nonitice: "No Notifications",
    chat: "Your chat list is empty",
  },
  tips: {
    loadfail: "Loading failed. Please try again.",
    savesuccess: "Save Success",
    deletedsuccess: "Deleted Success",
    usernotexist: "User does not exist",
    insufficientcredits: "Insufficient Credits",
    needupgrade: "Need to upgrade",
    sendfail: "Send Failed",
    sendsuccess: "Send Success",
    followsuccess: "Follow Success",
    contentcantempty: "Content can't empty",
    newpwd: "Please check your new password in email",
    nopermission: "You dont't have permission",
    loginsuccess: "Login success",
    loginfailed: "Login failed",
    followsuccess: "Follow success",
    followcancel: "Cancel follow",
    likesuccess: "Like success",
    likecancel: "Cancel like",
    loginsuccess: "Login success",
    loginfailed: "Login failed",
    pullrefresh: "Pull down to refresh...",
    loosingrefresh: "Release to refresh...",
    loading: "loading...",
    loadMore: "load more",
    nomore: "No more",
    underReview: "Regist success, Under review...",
    copysuccess: "Copy success",
    aproval: "Your account is pending approval...",
    nofreechat: "Free chat is used up. Please",
    continue: "and continue",
    upmember: " Upgrade Member ",
    upmember1: " Upgrade Member ",
    upmember2: " Upgrade Member ",
    nouserfound: "No users found",
  },
  general: {
    title1: "Mass Mailing",
    item1: "Subscribe to newsletter",
    tips1: "Uncheck this box to stop receiving mass-mailing",
  },
  notification: {
    general: "GENERAL",
    notice: "MAIL NOTIFICATIONS",
    title1: "Base",
    title2: "Newsfeed",
    title3: "Messages",
    title4: "Photo",
    title5: "Video",
    title6: "Credits",
    title7: "Gifts",
    title8: "Also send by email",
    item1: "Someone comments on my profile",
    item2: "Someone comments on my status",
    item3: "Someone likes my status",
    item4: "Someone writes on my wall",
    item5: "Someone sends me a new mail message",
    item6: "Someone sends me a new chat message",
    item7: "Someone comments on my photo",
    item8: "Someone comments on my video",
    item9: "Someone grants me credits",
    item10: "Someone sends me a gift",
    item11: "Immediately",
    item12: "Automatically (if you don't show up on the site for 2 days)",
    item13: "never",
  },
  navigator: {
    message: "Messages",
    notice: "Notifications",
    profile: "My Profile",
    edit: "Profile Edit",
    general: "My Preferences",
    mail: "Mail Notifications",
    signout: "Sign Out",
  },
  account: {
    account: "Account",
    quantity: "Remaining quantity",
    choose: "Select the recharge type",
    service: "Service",
    totalprice: "Total price",
    save: "Province",
    membership: "Membership privileges",
  },
  date: {
    second: "seconds ago",
    minute: "minutes ago",
    hour: "hours ago",
    month: "month",
    just: "Just",
    month1: "Jay.",
    month2: "Fer.",
    month3: "Mar.",
    month4: "Apr.",
    month5: "May.",
    month6: "Jun.",
    month7: "Jul.",
    month8: "Aug.",
    month9: "Sept.",
    month10: "Oct.",
    month11: "Nov.",
    month12: "Dec.",
  },
  chat: {
    photo: "Photo",
    uploading: "Uploading photo",
    sending: "Sending",
    waitingConnection: "Waiting for connection",
    sent: "Sent",
    retry: "Retry",
    removePhoto: "Remove",
    loadingImage: "Loading photo",
    loadImageFailed: "Photo failed to load",
    retryImage: "Reload",
    uploadFailed: "Upload failed. Please retry.",
    sendFailed: "Sending failed. Please retry.",
    confirmTimeout: "Confirmation has not arrived. You can retry.",
    unsupportedImage: "Choose a JPG, PNG, GIF or WebP image.",
    imageTooLarge: "This photo is too large. Please resize it.",
    imageUnreadable: "Unable to read this photo. Please choose another.",
    imageUnavailable: "Photo unavailable. Please select it again.",
    loginExpired: "Your session expired. Please sign in.",
    upgradeRequired: "Upgrade your membership to send photos.",
    recipientUnavailable: "Recipient unavailable",
    connectionLost: "Reconnecting. Your text is kept; please send again shortly.",
    reconnecting: "Reconnecting to chat…",
    connecting: "Connecting to chat…",
    offline: "You are offline. Chat will reconnect when your network returns.",
    noHistory: "No more messages",
    historyFailed: "Unable to load history. Please retry.",
    queryhistory: "Query history",
    active: "active",
    chatlist: "Chat list",
  },
  mine: {
    membership: "Membership",
    free: "Free",
    expires: "Expires",
    goldcard: "Crown Card",
    silvercard: "Diamond Card",
    permanent: "-",
    newsfeeds: "Newsfeeds",
    balance: "Balance",
    recharge: "Recharge",
    upgrade: "Upgrade",
    gift: "Gift",
    giftMine: "My Gifts",
    albums: "Albums",
    video: "Video",
    customerservice: "Customer Service",
    index: "Index",
    newsfeed: "Newsfeed",
    message: "Message",
    mine: "Mine",
  },
  tab: {
    chat: "Chats",
    mail: "Mails",
    customer: "Customer",
  },
  country: {
    AD: "Andorra",
    AE: "The United Arab Emirates",
    AF: "Afghanistan",
    AG: "Antigua and Barbuda",
    AI: "Anguilla",
    AL: "Albania",
    AM: "Armenia",
    AO: "Angola",
    AQ: "Antarctica",
    AR: "Argentina",
    AS: "American Samoa",
    AT: "Austria",
    AU: "Australia",
    AW: "Aruba",
    AX: "Oran Islands",
    AZ: "Azerbaijan",
    BA: "Bosnia and Herzegovina",
    BB: "Barbados",
    BD: "Bengal",
    BE: "Belgium",
    BF: "burkina faso",
    BG: "Bulgaria",
    BH: "Bahrain",
    BI: "burundi",
    BJ: "Benin",
    BL: "Saint-Barthelemy",
    BM: "Bermuda",
    BN: "Brunei",
    BO: "bolivia",
    BQ: "Caribbean Netherlands",
    BR: "Brazil",
    BS: "Bahamas",
    BT: "Bhutan",
    BV: "Babe",
    BW: "botswana",
    BY: "Belarus",
    BZ: "Belize",
    CA: "Canada",
    CC: "Cocos Islands",
    CD: "Congo (gold)",
    CF: "Central African",
    CG: "Congo (cloth)",
    CH: "Switzerland",
    CI: "Cote d'Ivoire",
    CK: "Cook Islands",
    CL: "Chile",
    CM: "Cameroon",
    CN: "China",
    CO: "Columbia",
    CR: "Costa Rica",
    CU: "Cuba",
    CV: "Cape Verde",
    CX: "Christmas Island",
    CY: "Cyprus",
    CZ: "Czech",
    DE: "Germany",
    DJ: "Djibouti",
    DK: "Denmark",
    DM: "Dominica",
    DO: "Dominican",
    DZ: "Algeria",
    EC: "Ecuador",
    EE: "Estonia",
    EG: "Egypt",
    EH: "Western Sahara",
    ER: "Eritrea",
    ES: "Spain",
    ET: "Ethiopia",
    FI: "Finland",
    FJ: "Fiji Islands",
    FK: "Malvinas Islands",
    FM: "Federated States of Micronesia",
    FO: "Faroe Islands",
    FR: "France",
    GA: "Gabon",
    GB: "Britain",
    GD: "Grenada",
    GE: "Georgia",
    GF: "French Guiana",
    GG: "Guernsey",
    GH: "Ghana",
    GI: "Gibraltar",
    GL: "Greenland",
    GM: "Gambia",
    GN: "Guinea",
    GP: "Gua de Ropp",
    GQ: "Equatorial Guinea",
    GR: "Greece",
    GS: "South Georgia island and South Sandwich Islands",
    GT: "Guatemala",
    GU: "Guam",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HM: "Hird island and Macdonald Islands",
    HN: "Honduras",
    HR: "Croatia",
    HT: "Haiti",
    HU: "Hungary",
    ID: "Indonesia",
    IE: "Ireland",
    IL: "Israel",
    IM: "Isle of man",
    IN: "India",
    IO: "British India Ocean Territory",
    IQ: "Iraq",
    IR: "Iran",
    IS: "Iceland",
    IT: "Italy",
    JE: "Jersey",
    JM: "Jamaica",
    JO: "Jordan",
    JP: "Japan",
    KE: "Kenya",
    KH: "Cambodia",
    KG: "Kyrgyzstan",
    KI: "Kiribati",
    KM: "Comoros",
    KN: "Saint kit and Nevis",
    KP: "North Korea",
    KR: "The Republic of Korea",
    KW: "Kuwait",
    KY: "Cayman Islands",
    KZ: "Kazakhstan",
    LA: "Laos",
    LB: "Lebanon",
    LC: "Saint Lucia",
    LI: "Liechtenstein",
    LK: "Sri Lanka",
    LR: "Liberia",
    LS: "Lesotho",
    LT: "Lithuania",
    LU: "Luxembourg",
    LV: "Latvia",
    LY: "Libya",
    MA: "Morocco",
    MC: "Monaco",
    MD: "Moldova",
    ME: "Montenegro",
    MF: "saint martin",
    MG: "Madagascar",
    MH: "Marshall Islands",
    MK: "Macedonia",
    ML: "Mali",
    MN: "The state of Mongolia",
    MM: "Myanmar",
    MP: "Northern Mariana Islands",
    MQ: "Martinique",
    MR: "Mauritania",
    MS: "Montserrat",
    MT: "Malta",
    MU: "Mauritius",
    MV: "Maldives",
    MW: "Malawi",
    MX: "Mexico",
    MY: "Malaysia",
    MZ: "Mozambique",
    NA: "Namibia",
    NC: "New Caledonia",
    NE: "Niger",
    NF: "Norfolk Island",
    NG: "Nigeria",
    NI: "Nicaragua",
    NO: "Norway",
    NP: "Nepal",
    NR: "Nauru",
    NU: "Newer",
    NZ: "New Zealand",
    OM: "Oman",
    PA: "Panama",
    PE: "Peru",
    PF: "French Polynesia",
    PG: "papua new guinea",
    PH: "The Philippines",
    PK: "Pakistan",
    PL: "poland",
    PM: "Saint Pierre and the clone",
    PN: "Pete Kaine Islands",
    PR: "Puerto Rico",
    PS: "Palestine",
    PT: "Portugal",
    PW: "Palau",
    PY: "Paraguay",
    QA: "Qatar",
    RE: "Reunion",
    RO: "Romania",
    RS: "Serbia",
    RU: "Russia",
    RW: "Rwanda",
    SA: "New Zealand",
    SB: "Solomon Islands",
    SC: "Seychelles",
    SD: "Sultan",
    SG: "Singapore",
    SH: "St. Helena",
    SI: "Slovenia",
    SJ: "Svalbard Islands and Jan Mayen",
    SK: "Slovakia",
    SL: "sierra leone",
    SM: "San Marino",
    SN: "Senegal",
    SO: "Somalia",
    SR: "Suriname",
    SS: "South Sudan",
    ST: "Sao Tome and Principe",
    SV: "Salvatore",
    SY: "Syria",
    SZ: "Swaziland",
    TC: "Turks and Caicos Islands",
    TD: "Chad",
    TF: "French Southern Territories",
    TG: "Togo",
    TH: "Thailand",
    TJ: "Tajikistan",
    TK: "Tokelau",
    TL: "Timor-Leste",
    TM: "Turkmenistan",
    TN: "Tunisia",
    TO: "Tonga",
    TR: "Turkey",
    TT: "Trinidad and Tobago",
    TV: "Tuvalu",
    TZ: "Tanzania",
    UA: "Ukraine",
    UG: "Uganda",
    UM: "Small islands outside the United States",
    US: "U.S.A",
    UZ: "Uzbekistan",
    UY: "Uruguay",
    VA: "Vatican",
    VC: "Saint Vincent and the grand",
    VE: "Venezuela",
    VG: "British Virgin Islands",
    VI: "Virgin Islands",
    VN: "Vietnam?",
    VU: "Vanuatu",
    WF: "Wallis and f.",
    WS: "Samoa",
    YE: "Yemen",
    YT: "Ma",
    ZA: "South Africa",
    ZM: "Zambia",
    ZW: "zimbabwe",
  },
  report: {
    ads: "ADS",
    offensive: "Offensive",
    illegal: "illegal",
    content: "The content of reporting %{user} is...",
    success:
      "Please wait for the administrator to inform you of the report result",
  },
  notice: {
    report: {
      result: "Report results",
      reportdetail: "The administrator has accepted your report information",
    },
    gift: {
      receive: "Received a gift",
      from: "From:",
      leavemsg: "Leaving a message:",
    },
  },
  globalgift: {
    sendto: "SEND GIFT TO",
    credits: "Credits",
    balance: "Credit balance",
    psag: "Please select a gift",
    message: "Message",
    nogift: "Please fill the form properly",
  },
};
